module.exports = __webpack_public_path__ + "img/simon_zsuzsanna_reszketes_2_2.c9b6cc55.jpg";